// src/index.js
import { initSentry, SentryAppBoundary } from "./observability/sentry";
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import LocaleProvider from './LocaleProvider';
import AnimatedText from "components/universal/AnimatedText/AnimatedText";
import '@fontsource/be-vietnam/400.css'; // Regular
import '@fontsource/be-vietnam/500.css'; // Medium
import '@fontsource/be-vietnam/700.css'; // Bold
import 'antd/dist/reset.css';
import './css/index.css';

initSentry();

const faviconUrl = process.env.REACT_APP_FAVICON_URL;
const name = process.env.REACT_APP_NAME;

// Set app's favicon and document title
const link = document.createElement("link");
link.rel = "icon";
link.href = faviconUrl;
document.head.appendChild(link);
document.title = name;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryAppBoundary>
      <I18nextProvider i18n={i18n}>
        <Suspense
          fallback={
            <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              <AnimatedText
                text={"Starting application..."}
                animationType="wave"
                size="large"
              />
            </div>
          }
        >
          <LocaleProvider>
            <App />
          </LocaleProvider>
        </Suspense>
      </I18nextProvider>
    </SentryAppBoundary>
  </React.StrictMode>
);

reportWebVitals();